 
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import Link from 'next/link';

import type { NavItem } from './NavItems';

type Props = {
  items: NavItem[];
  pathname?: string | null;
  onItemClick?: () => void;
};

export default function DrawerList({ items, pathname, onItemClick }: Props) {
  return (
    <Box sx={{ width: '100%' }} role="presentation">
      <List>
        {items.map((item) => {
          const isActive = pathname === item.href || (item.href !== '/' && pathname?.startsWith(item.href));

          return (
            <ListItem key={item.text} disablePadding>
              {item.external ? (
                <ListItemButton component="a" href={item.href} target="_blank" rel="noopener noreferrer" selected={false} onClick={onItemClick}>
                  {item.icon && <ListItemIcon>{item.icon}</ListItemIcon>}
                  <ListItemText primary={item.text} />
                </ListItemButton>
              ) : (
                <ListItemButton component={Link} href={item.href} selected={isActive} onClick={onItemClick}>
                  {item.icon && <ListItemIcon>{item.icon}</ListItemIcon>}
                  <ListItemText primary={item.text} />
                </ListItemButton>
              )}
            </ListItem>
          );
        })}
      </List>
    </Box>
  );
}
